import {
  ModelConceptHierarchy,
  ModelConceptHierarchyLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { LinkData, NodeData } from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptHierarchy,
  isModelConceptHierarchyLabel,
} from 'src/containers/ProjectDiagram/utils/data';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

export const getConnectedHierarchyDataForClass = (
  { linkDataArray }: { linkDataArray: LinkData[] },
  iri: string
) => {
  return linkDataArray.filter(
    (linkData): linkData is ModelConceptHierarchy =>
      isModelConceptHierarchy(linkData) &&
      (linkData.from === getModelConceptClassKey(iri) ||
        linkData.to === getModelConceptClassKey(iri))
  );
};

export const getConnectedHierarchyLabelDataForClass = (
  { nodeDataArray }: { nodeDataArray: NodeData[] },
  iri: string
) => {
  return nodeDataArray.filter(
    (nodeData): nodeData is ModelConceptHierarchyLabel =>
      isModelConceptHierarchyLabel(nodeData) &&
      (nodeData.from === getModelConceptClassKey(iri) ||
        nodeData.to === getModelConceptClassKey(iri))
  );
};
